// src/nhost.js
import { NhostClient } from '@nhost/nhost-js'

const nhost = new NhostClient({
  subdomain: 'oojbgyspwbwvnpxnokol',
  region: 'ap-southeast-1'
})

export default nhost
